export const BOOKING_STEPS = {
  CREATED: 'created',
  MESSAGE: 'message',
  MOVE_IN_OUT: 'moveinout',
  PAYMENT_FAIL: 'payment-fail',
  PAYMENT_CHECKOUT: 'payment-checkout',
};
